import ModelCard from './ModelCard';
import type { Model } from '../../api';

interface ModelListProps {
  models: Model[];
  onAttach?: (model: Model) => void;
  onEdit?: (model: Model) => void;
  onDelete?: (model: Model) => void;
}

export default function ModelList({ models, onAttach, onEdit, onDelete }: ModelListProps) {
  if (!models || models.length === 0) {
    return (
      <div className="py-16 text-center text-muted-foreground">
        <p className="text-[15px] font-medium">No models registered</p>
        <p className="mt-1 text-[13px]">Add an analytics model to start running AI on your cameras.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {models.map((model) => (
        <ModelCard key={model.id} model={model} onAttach={onAttach} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
}
